import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=2bc1bf0f&"
import script from "./UserView.vue?vue&type=script&lang=js&"
export * from "./UserView.vue?vue&type=script&lang=js&"
import style0 from "./UserView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
